<template>
  <div>
    <!-- ✅ APROVAR -->
    <c-q-btn
      v-if="showApproveButton"
      id="btn-approve-institutional"
      propBtnLabel="Aprovar"
      :propBtnFunction="onApproveInstitutional"
      :propBtnTransparent="false"
      :propBtnSize="EnumButtonSizes.LARGE_1"
    />

    <!-- ✅ REAPROVAR -->
    <c-q-btn
      v-if="showReapproveButton"
      id="btn-reapprove-institutional"
      propBtnLabel="Reaprovar"
      :propBtnFunction="onReapproveInstitutional"
      :propBtnTransparent="false"
      :propBtnSize="EnumButtonSizes.LARGE_1"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

import { EnumButtonSizes, EnumRouteNames } from '@/enums/enums'

import { useInstitutionalStore } from '@/stores/institutionalStore'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useAuthStore } from '@/stores/authStore'

import { CONST_INSTITUTIONAL_STATUS } from '@/static/constantsInstitutional'

import messages from '@/utils/messages'

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()
const authStore = useAuthStore()
const router = useRouter()

/**
 * ✅ SHOW APPROVE
 */
const showApproveButton = computed(() => {
  return (
    authStore.currentUserCanReviewInstitutional &&
    institutionalStore.institutionalDetail?.status ===
      CONST_INSTITUTIONAL_STATUS.ON_APPROVAL.id
  )
})

/**
 * ✅ SHOW REAPPROVE
 */
const showReapproveButton = computed(() => {
  return (
    authStore.currentUserCanReviewInstitutional &&
    institutionalStore.institutionalDetail?.status ===
      CONST_INSTITUTIONAL_STATUS.ON_RE_APPROVAL.id
  )
})

/**
 * ✅ APROVAR
 */
const onApproveInstitutional = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.approveInstitutional(id)

    institutionalStore.clearReviewData()

    messages.showSuccessMsg('Cadastro aprovado com sucesso!')
  } catch (error: any) {
    console.error(error)
    messages.showErrorMsg(
      error?.response?.data?.message || 'Erro ao aprovar cadastro.'
    )
  } finally {
    pagesUtilStore.showLoading = false
  }
}

const onReapproveInstitutional = async () => {
  try {
    pagesUtilStore.showLoading = true

    const id = institutionalStore.institutionalDetail?.id
    if (!id) return

    await institutionalStore.reapproveInstitutional(id)

    institutionalStore.clearReviewData()

    messages.showSuccessMsg('Cadastro reaprovado com sucesso!')

    router.push({
      name: EnumRouteNames.INSTITUTIONAL_VIEW,
      params: { id }
    })
  } catch (error: any) {
    console.error(error)
    messages.showErrorMsg(
      error?.response?.data?.message || 'Erro ao reaprovar cadastro.'
    )
  } finally {
    pagesUtilStore.showLoading = false
  }
}

</script>

<style scoped>
</style>